
export default [{name: "Undefined mode", colour: "#555555"},
                {name: "Standby", colour: "#777777"},
                {name: "Transit", colour: "#114466"},
                {name: "DP", colour: "#336644"},
                {name: "Towing", colour: "#663333"},
                {name: "AnchorHandling", colour: "#666633"}];
